var formAction =
  "https://landingreceiver.youandemili.com/api/v1/landing/process/json";
var gdprFormDescriptor =
  "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";

var configFile =
  "content/data/contents.json?v=" +
  new Date().getTime();
var genericError = "";
var userExistError = "";
var successTitle = "";
var successMessage = "";
var errorMessage = "";
var errorMessageEmail = "";
var errorMessagePhone = "";

const nllid = "-";
const nlbelid = "-";

const recaptchaActionName = "trattori_alta_potenza_2026";

$(document).ready(function () {
  ViewPortHeight();

  jQuery.validator.addMethod(
    "notNumber",
    function (value, element, param) {
      var reg = /[0-9]/;
      if (reg.test(value)) {
        return false;
      } else {
        return true;
      }
    },
    "Numbers not allowed"
  );

  $("#phonenumber").keypress(function (e) {
    if (String.fromCharCode(e.which).match(/[^+()0-9 \-]/)) {
      e.preventDefault();
    }
  });

  $("#city").keypress(function (e) {
    var charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
    if (/\d/.test(charStr)) {
      e.preventDefault();
    }
  });

  $(".ae-btn-submit").attr("disabled", "disabled");

  getData();

  configLandigReceiver();
  initRecaptcha();

  $(".scroll-link").click(function (e) {
    e.preventDefault();

    $(window).stop(true).scrollTo(this.hash, {
      duration: 50,
      offset: 0,
      easing: "easeOutCirc",
    });
  });


  var copyText = $("#ae-copyright").html();
  var currentYear = new Date().getFullYear();
  copyText = copyText.replace("{year}", currentYear);
  $("#ae-copyright").html(copyText);
   
});

$(window).on("resize", function () {
  ViewPortHeight();
});

/***** FUNCTIONS  *****/

function ViewPortHeight() {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

function isPoland() {
  return $("#promo").val().toLowerCase() === "pl";
}

function getData() {
  var promo = $("#promo").val();
  //console.log("Promo: " + promo);
  var found = false;
  $.getJSON(configFile, function (data) {
    $.each(data, function (k, level1) {
      $.each(level1, function (k1, val) {
        if (promo == val["promo"]) {
          found = true;
          var promoData = val["data"];
          $("#lid").val(promoData["lid"]);
          $("#landingName").val(promoData["landingName"]);
          $("#language").val(promoData["language"]);
          $("#productbrand").val(promoData["productbrand"]);
          $("#codepromotion").val(promoData["codepromotion"]);
          $("#contactlanguage").val(promoData["contactlanguage"]);
          genericError = promoData["genericError"];
          userExistError = promoData["userExistError"];
          successTitle = promoData["successTitle"];
          successMessage = promoData["successMessage"];
          errorMessage = promoData["errorMessage"];
          errorMessageEmail = promoData["errorMessageEmail"];
          errorMessagePhone = promoData["errorMessagePhone"];

          $("#purchaseintention").on("change", function () {
            setPurchaseIntentionText();
          });

          $(".ae-benelux-country").on("change", function () {
            var v = $(this).val();
            if (v == "Netherlands") {
              $("#lid").val(nllid);
            } else {
              $("#lid").val(nlbelid);
            }
          });
        }
      });
    });

    /** GDPR **/
    GetFormDescriptor();
    setFormValidation();

    if (!found) {
      console.log("not found");
    }
  });
}

function setPurchaseIntentionText() {
  $("#purchaseintentionText").val(
    $("#purchaseintention option:selected").text()
  );
}

function setFormValidation() {
  //form validate
  $("#landing-form").validate({
    invalidHandler: function (form, validator) {
      var errors = validator.numberOfInvalids();
      if (errors) {
        validator.errorList[0].element.focus();
      }
    },
    errorElement: "span",
    rules: {
      city: "notNumber",
    },
    messages: {
      firstname: errorMessage,
      lastname: errorMessage,
      phonenumber: errorMessage,
      postalcode: errorMessage,
      city: {
        required: errorMessage,
        notNumber: "Numbers are not allowed",
      },
      purchaseintention: errorMessage,
      model: errorMessage,
      email: {
        required: errorMessage,
        email: errorMessageEmail,
      },
      gdpr_0: errorMessage,
      gdpr_1: errorMessage,
      gdpr_2: errorMessage,
    },
  });
}

function configLandigReceiver() {
  //campaign tracking
  var gtmref = getUrlParameter("utm_source");
  var gtmcampaign = getUrlParameter("utm_campaign");
  var gtmmedium = getUrlParameter("utm_medium");
  var gtmcontent = getUrlParameter("utm_content");
  var placement = getUrlParameter("placement");
  var utmPlacement = getUrlParameter("utm_placement"); //used if placement is not setted, but utm_placement is set
  var adset = getUrlParameter("adset");
  var campaignname = getUrlParameter("campaign_name");

  if (gtmref != undefined) {
    $("#gtmref").val(gtmref);
  }
  if (gtmcampaign != undefined) {
    $("#gtmcampaign").val(gtmcampaign);
  }

  if (gtmmedium != undefined) {
    $("#gtmmedium").val(gtmmedium);
  }

  if (gtmcontent != undefined) {
    $("#gtmcontent").val(gtmcontent);
  }

  if (placement != undefined) {
    $("#placement").val(placement);
  }

  //used if placement is not setted, but utm_placement is set
  if (utmPlacement != undefined) {
    if (placement == undefined) {
      $("#placement").val(utmPlacement);
    }
  }

  if (adset != undefined) {
    $("#adset").val(adset);
  }

  if (campaignname != undefined) {
    $("#campaignname").val(campaignname);
  }

  //final form post
  $("#landing-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (isPoland()) {
      if (!validateChannelCheckboxes()) {
        return false;
      }
    }

    var form = $("#landing-form");

    var gdprMarketing = $("input[name=gdpr_1]:checked").val();
    var gdprMarketingThird = $("input[name=gdpr_2]:checked").val();

    if (gdprMarketing === "1" || gdprMarketingThird === "1") {
      $("#contact_email").val("1");
      $("#contact_phone").val("1");
      $("#contact_sms").val("1");
    } else {
      $("#contact_email").val("0");
      $("#contact_phone").val("0");
      $("#contact_sms").val("0");
    }

    if (form.valid()) {
      $(".ae-btn-submit").attr("disabled", "disabled");
      $("#waiting-form").removeClass("d-none");

      //se #phonenumber non inizia con +39 aggiungo il prefisso
      var ph = $("#phonenumber").val(); 
      var prefix = "+39";
      if (ph.length > 0 && !ph.startsWith(prefix)) {
        $("#phonenumber").val(prefix + ph);
      }

      postData(form);
    }
    return false;
  });
}

function postData(form) {
  var formData = form.serializeArray();

  var fieldsToReomve = [
    "gdpr_contacts_10",
    "gdpr_contacts_11",
    "gdpr_contacts_12",
  ];
  formData = formData.filter(function (item) {
    return !fieldsToReomve.includes(item.name);
  });

  var jsonData = {
    url: window.location.href,
    name: $("#landingName").val(),
    id: $("#lid").val(),
    data: objectifyForm(formData),
  };

  //console.log(jsonData);

  //post
  $.ajax({
    async: true,
    type: "POST",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: formAction,
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(jsonData),
    success: function (resp) {
      //console.log(resp);
      var obj = JSON.parse(JSON.stringify(resp));
      if (obj.status === 1) {
        try {
          //Tracciamento del form inviato
          /**** GTM Navigation Event ****/
          if (typeof dataLayer !== "undefined") {
            dataLayer.push({
              event: "Pageview",
              pagePath:
                location.pathname.replace("index.html", "") + "/form-send/",
              pageTitle: "Forn send | " + $(document).find("title").text(),
            });
          }

          showSuccess();
          document.getElementById("landing-form").reset();
        } catch (err) {
          console.log(err);
          showError(genericError);
        }

        $(".ae-btn-submit").removeAttr("disabled");
        $("#waiting-form").addClass("d-none");
        initRecaptcha();
      }
    },
    error: function (err) {
      var obj = JSON.parse(JSON.stringify(err));
      //console.log("ERR");
      //console.log(obj);
      if (obj.status === 400) {
        var objResp = JSON.parse(JSON.stringify(obj.responseJSON));
        console.log(obj.responseJSON);
        if (objResp.status === 3) {
          var em = "";
          //console.log(objResp.validationErrors);
          $.each(objResp.validationErrors, function (k, er) {
            if (er["fieldName"] == "phonenumber") {
              em = em + errorMessagePhone + "<br />";
            }
            if (er["fieldName"] == "email") {
              em = em + errorMessageEmail + "<br />";
            }
          });
          if (em.length == 0) {
            em = genericError;
          }
          showError(em);
        } else if (objResp.status === 4) {
          //email esistente
          showError(userExistError);
        } else {
          showError(genericError);
        }
      }
      $(".ae-btn-submit").removeAttr("disabled");
      $("#waiting-form").addClass("d-none");
      initRecaptcha();
    },
  });
}

function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(
    window.location.href.substring(window.location.href.indexOf("?") + 1)
  ),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
}

//create json from form data
function objectifyForm(formArray) {
  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]["name"]] = formArray[i]["value"];
  }
  return returnArray;
}

function showError(err) {
  bootbox.alert({
    centerVertical: true,
    message:
      '<h5 class="text-danger text-uppercase"></h5><div class="text-danger">' +
      err +
      "</div>",
  });
}

function showSuccess() {
  bootbox.alert({
    centerVertical: true,
    message:
      '<div id="form-success"><h5 class="text-uppercase ae-lid-form-success">' +
      successTitle +
      "</h5><div>" +
      successMessage +
      "</div></div>",
  });
}

/**** GDPR ****/

function GetFormDescriptor() {
  $.ajax({
    async: true,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: gdprFormDescriptor,
    success: function (resp) {
      if (resp != null) {
        $("#gdpr").val(JSON.stringify(resp));
        GenerateFields(resp);

        if (isPoland()) {
          EnableGDPRPolandValidation();
        }

        $(".ae-btn-submit").removeAttr("disabled");
        $("#landing-form").addClass("opacity-100");
      }
      
    },
    error: function (resp) {
      //console.log(resp)
      
    },
  });
}

function GenerateFields(x) {
  $.each(x, function (key, val) {
    if (key === "policies") {
      $.each(val, function (index, value) {
        if (value.type === "checkbox") {
          if (value.id === 4) {
            GenerateHiddenChecbox(value);
          } else {
            GenerateChecbox(value);
          }
        }

        if (value.type === "radio") {
          GenerateRadio(value);
        }

        if (value.type === "checkbox_contacts") {
          GenerateChecboxContacts(value);
        }
      });
    }
  });
}

function GenerateChecbox(policy) {
  var description = policy.description + " *";

  var html =
    '<div class="form-group custom-control form-check">' +
    '<input type="checkbox" class="form-check-input gdpr-checkbox" name="gdpr_' +
    policy.id +
    '" id="gdpr_' +
    policy.id +
    '" value="1" ' +
    (policy.required ? "required" : "") +
    " />" +
    '<label class="form-check-label" for="gdpr_' +
    policy.id +
    '">' +
    description +
    " </label>" +
    "</div>";

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}

function GenerateChecboxContacts(policy) {
  var html =
    '<div class="form-group custom-control form-check">' +
    '<input type="checkbox" class="form-check-input gdpr-checkbox" name="gdpr_contacts_' +
    policy.id +
    '" id="gdpr_contacts_' +
    policy.id +
    '" value="1" ' +
    (policy.required ? "required" : "") +
    'data-policy="gdpr_' +
    policy.id +
    '" />' +
    '<label class="form-check-label" for="gdpr_contacts_' +
    policy.id +
    '">' +
    policy.description +
    " </label>" +
    '<input type="hidden" name="gdpr_' +
    policy.id +
    '" id="gdpr_' +
    policy.id +
    '"  />' +
    "</div>";

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}

function GenerateHiddenChecbox(policy) {
  var html =
    '<div class="form-group">' +
    '<input type="hidden" name="gdpr_' +
    policy.id +
    '" id="gdpr_' +
    policy.id +
    '"  />' +
    '<label class="form-check-label" for="gdpr_' +
    policy.id +
    '" id="gdpr-label-' +
    policy.id +
    '">' +
    policy.description +
    "<span> *</span></label>" +
    "</div>";

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}

function GenerateRadio(policy) {
  var html =
    ' <div class="form-group"> ' +
    '<div><div class="gdpr-scrollable">' +
    '<span class="gdpr-policy-title">' +
    policy.title +
    " *</span><br />" +
    policy.description +
    "<br />" +
    "</div>" +
    '<div class="form-check form-check-inline">' +
    '<input class="form-check-input gdpr-radio" type="radio" name="gdpr_' +
    policy.id +
    '" id="gdpr_' +
    policy.id +
    '-0" value="1" required />' +
    '<label class="form-check-label" for="gdpr_' +
    policy.id +
    '-0">' +
    policy.accept_label +
    "</label>" +
    "</div>" +
    '<div class="form-check form-check-inline">' +
    '<input class="form-check-input gdpr-radio" type="radio" name="gdpr_' +
    policy.id +
    '" id="gdpr_' +
    policy.id +
    '-1" value="0" /> ' +
    '<label class="form-check-label" for="gdpr_' +
    policy.id +
    '-1">' +
    policy.deny_label +
    "</label>" +
    "</div>" +
    "</div></div>";

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}

/*** GDPR PL ***/

// 1) Disabilita le checkbox di default
function disableChannelCheckboxes() {
  $("#gdpr-label-4").addClass("disabled");
  $("#gdpr-label-4").find("span").addClass("d-none");
  $("#gdpr_contacts_10, #gdpr_contacts_11, #gdpr_contacts_12")
    .prop("disabled", true)
    .prop("checked", false);
  // Nascondi eventuali messaggi di errore
  $(".channel-error").remove();
}

// Abilita le checkbox
function enableChannelCheckboxes() {
  $("#gdpr-label-4").removeClass("disabled");
  $("#gdpr-label-4").find("span").removeClass("d-none");
  $("#gdpr_contacts_10, #gdpr_contacts_11, #gdpr_contacts_12").prop(
    "disabled",
    false
  );
}

// Aggiorna il campo gdpr_4 e gestisce le checkbox
function updateGdprStatus() {
  var gdpr1Accepted = $("#gdpr_1-0").is(":checked");
  var gdpr2Accepted = $("#gdpr_2-0").is(":checked");

  // Se almeno uno dei due consensi è "Wyrażam zgodę"
  if (gdpr1Accepted || gdpr2Accepted) {
    $("#gdpr_4").val("1");
    enableChannelCheckboxes();
  } else {
    $("#gdpr_4").val("0");
    $("#gdpr_10").val("0");
    $("#gdpr_11").val("0");
    $("#gdpr_12").val("0");
    disableChannelCheckboxes();
  }
}

// Validazione delle checkbox - almeno una deve essere selezionata
function validateChannelCheckboxes() {
  var isEnabled = !$("#gdpr_contacts_10").prop("disabled");

  if (!isEnabled) {
    return true; // Se sono disabilitate, non serve validare
  }

  var atLeastOneChecked =
    $("#gdpr_contacts_10").is(":checked") ||
    $("#gdpr_contacts_11").is(":checked") ||
    $("#gdpr_contacts_12").is(":checked");

  // Rimuovi messaggi di errore precedenti
  $(".channel-error").remove();

  if (!atLeastOneChecked) {
    // Aggiungi messaggio di errore
    $("#gdpr_contacts_12")
      .closest(".form-group")
      .after(
        '<span class="error channel-error">Musisz wybrać przynajmniej jeden kanał komunikacji.</span>'
      );
    return false;
  }

  return true;
}

function EnableGDPRPolandValidation() {
  disableChannelCheckboxes();
  $("#gdpr_4").val("0");
  $("#gdpr_10").val("0");
  $("#gdpr_11").val("0");
  $("#gdpr_12").val("0");

  // Event listener sui radio button
  $('input[name="gdpr_1"], input[name="gdpr_2"]').on("change", function () {
    updateGdprStatus();
  });

  // Event listener sulle checkbox per rimuovere errore quando viene selezionata una checkbox
  $("#gdpr_contacts_10, #gdpr_contacts_11, #gdpr_contacts_12").on(
    "change",
    function () {
      if ($(this).is(":checked")) {
        $(".channel-error").remove();
        $("#" + $(this).data("policy")).val("1");
      } else {
        $("#" + $(this).data("policy")).val("0");
      }
    }
  );
}

/*** RECAPTCHA ***/

function initRecaptcha() {
  var lang = $("#promo").val().toLowerCase().replace("-", "_");
  var act = recaptchaActionName + "_" + lang;
  if (grecaptcha?.enterprise && $("#recaptcha").length) {
    $(".ae-btn-submit").attr("disabled", "disabled");
    if (this.recaptchaIniting) return;
    this.recaptchaIniting = true;
    //console.log("initRecaptcha");
    grecaptcha.enterprise.ready(() => {
      //console.log("initRecaptcha ready");
      grecaptcha.enterprise
        .execute("6LcCjusqAAAAAOizm6S_Zx2v79kjLqHuNTsLO4R8", { action: act })
        .then((token) => {
          //console.log("initRecaptcha new token", act);
          $("#recaptcha").val(token);
          $(".ae-btn-submit").removeAttr("disabled");
          this.recaptchaIniting = false;
          this.isLoading = false;
        });
    });
    clearInterval(this.recaptchaInterval);
    this.recaptchaInterval = setInterval(
      () => this.initRecaptcha(),
      60 * 2 * 1000
    );
  } else {
    this.isLoading = false;
  }
}

$(window).on("scroll", function () {
  if ($(window).width() < 992) {
    if (inViewport($(".ae-body-container"))) {
      $(".ae-mobile-fixed-cta").addClass("ae-hide-transition");
      $(".ae-mobile-fixed-cta").removeClass("ae-hide");
    } else {
      $(".ae-mobile-fixed-cta").removeClass("ae-hide-transition");
      $(".ae-mobile-fixed-cta").addClass("ae-hide");
    }
  }
});

function inViewport($el) {
  var elH = $el.outerHeight(),
    H = $(window).height(),
    r = $el[0].getBoundingClientRect(),
    t = r.top,
    b = r.bottom;
  return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
}
